import React from "react";
import LZUTF8 from "lzutf8";
import Contact from "./contact";
import Service from "./service";
import CardTable from "./cardTable";
import Totals from "./totals";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import Save from "@material-ui/icons/Save";
import { Parser } from "json2csv";
import fileDownload from "js-file-download";
import Disclaimer from "./disclaimer";
import toExcel from "../excel";

const useStyles = makeStyles((theme) => ({
  download: {
    paddingTop: theme.spacing() * 2,
    paddingBottom: theme.spacing() * 2,
    textAlign: "center",
  },
  blocker: {
    position: "fixed",
    height: "100vh",
    width: "100%",
    top: 0,
    left: 0,
    background: "#ffffff",
    zIndex: 10000,
    textAlign: "center",
    paddingTop: 50,
  },
}));

export default ({ location: { hash } }) => {
  const classes = useStyles();

  const {
    cards,
    contact,
    service,
    serviceLevels,
    cardsToEvaluatePrice,
    cardsToNotEvaluatePrice,
    currencyCaption,
  } = JSON.parse(
    LZUTF8.decompress(hash.substr(1), { inputEncoding: "Base64" })
  );

  const downloadCsv = () =>
    cards.length > 0
      ? fileDownload(
          Buffer.from(
            new Parser().parse(
              cards.map(({ id, ...restOfCard }) => ({
                ...restOfCard,
                ...contact,
              }))
            )
          ),
          `${new Date().getTime()}.csv`
        )
      : null;

  const downloadExcel = () =>
    cards.length > 0
      ? toExcel(`${window.location.protocol}//${window.location.host}`, {
          contact,
          cards,
          service,
          serviceLevels,
        }).then((buffer) =>
          fileDownload(buffer, `${new Date().getTime()}.xlsx`)
        )
      : null;

  return (
    <>
      <div className={classes.download}>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<Save />}
          onClick={downloadCsv}
          style={{ marginRight: 5 }}
        >
          CSV
        </Button>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<Save />}
          onClick={downloadExcel}
          style={{ marginLeft: 5 }}
        >
          Excel
        </Button>
      </div>
      <div id="print-target">
        <div style={{ pageBreakAfter: "always" }}>
          <Contact {...{ contact, isPrint: true }} />
          <Service
            {...{
              service,
              serviceLevels,
              isPrint: true,
              currencyCaption: currencyCaption || "$",
            }}
          />
        </div>
        <CardTable
          {...{ cards, isPrint: true, currencyCaption: currencyCaption || "$" }}
        />
        <div style={{ breakInside: "avoid-page", pageBreakInside: "avoid" }}>
          <Totals
            {...{
              cardsToEvaluatePrice,
              cardsToNotEvaluatePrice,
              currencyCaption: currencyCaption || "$",
              paymentDiscount: contact.paymentDiscount || 0,
            }}
          />
        </div>
        <div style={{ breakInside: "avoid-page", pageBreakInside: "avoid" }}>
          <Disclaimer />
        </div>
      </div>
    </>
  );
};
